import React from 'react';
import { Box } from './../components/layout/Grid';
import BaseSkeleton from './BaseSkeleton';

const BlogCardSkeleton = props => (
  <React.Fragment>
    <Box
      pb={'56.25%'}
      height={0}
      as={BaseSkeleton}
      mb="30px"
      animation={props.animation}
    />

    <BaseSkeleton
      height={10}
      width={100}
      marginBottom={20}
      animation={props.animation}
    />
    <BaseSkeleton
      height={10}
      width={100}
      marginBottom={20}
      animation={props.animation}
    />
    <BaseSkeleton
      height={10}
      width={60}
      marginBottom={20}
      animation={props.animation}
    />
  </React.Fragment>
);

export default BlogCardSkeleton;
